export * from './add-department-form';
export * from './assign-room';

import { AddDepartmentFormComponent } from './add-department-form';
import { AssignRoomToDepartmentComponent } from './assign-room';

export const DepartmentOrganisms = [
    AddDepartmentFormComponent,
    AssignRoomToDepartmentComponent
]